import {BaseModel} from '@/core/standard/BaseModel';
import PaymentsService from '@/modules/requests/requestsTables/PaymentsService';

const payment = {};

class PaymentModel extends BaseModel<any, any, typeof PaymentsService> {
  public modelName = 'Pago';

  constructor() {
    super(payment, PaymentsService);
  }
  
  public async closeWithDojo(data, toast) {
    const response = await PaymentsService.closeWithDojo({
      query: data,
    });
    if (response.complete) {
      this.handleSuccess(response, response.message, toast);
      return true;
    }
    this.handleError(response, toast);
    return false;
  }

  
  public async cancelCloseWithDojo(data, toast) {
    const response = await PaymentsService.cancelCloseWithDojo({
      query: data,
    });
    if (response.complete) {
      this.handleSuccess(response, response.message, toast);
      return true;
    }
    this.handleError(response, toast);
    return false;
  }

  
  public async closeWithCashmatic(data, toast) {
    const response = await PaymentsService.closeWithCashmatic({
      query: data,
    });
    if (response.complete) {
      this.handleSuccess(response, response.message, toast);
      return true;
    }
    this.handleError(response, toast);
    return false;
  }

  public async cancelCloseWithCashmatic(data, toast) {
    const response = await PaymentsService.cancelCloseWithCashmatic({
      query: data,
    });
    if (response.complete) {
      this.handleSuccess(response, response.message, toast);
      return true;
    }
    this.handleError(response, toast);
    return false;
  }

  public async confirmHandSign(data, toast) {
    const response = await PaymentsService.confirmPayment({query: data});
    if (response.complete) {
      this.handleSuccess(response, response.message, toast);
      return true;
    }
    this.handleError(response, toast);
    return false;
  }

  public async confirmPayment(data, toast) {
    const response = await PaymentsService.confirmPayment({query: data});
    if (response.complete) {
      this.handleSuccess(response, response.message, toast);
      return true;
    }
    this.handleError(response, toast);
    return false;
  }

  // public async changePaymentType(data: any, toast: any) {
  //   const response = await this.service.changePaymentType({query: data});
  //   if (response.complete) {
  //     this.handleSuccess(response, response.message, toast);
  //     return response.complete;
  //   }
  //   this.handleError(response, toast);
  //   return false;
  // }
}

export default PaymentModel as new() => any;
